module.exports = __webpack_public_path__ + "img/blog3.e313a352.png";